import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useThoughtSpotAPI } from "@/api";
import { LiveboardsQueryKey } from "@/hooks/useLiveboards";

type CreateLiveboardArgs = {
  liveboard_name: string;
};

export function useCreateLiveboard() {
  const api = useThoughtSpotAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (args: CreateLiveboardArgs) => {
      const response = await api.postThoughtspotLiveboardsCreate({
        liveboard_name: args.liveboard_name,
      });
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [LiveboardsQueryKey] });
    },
  });
}
